import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './Redux/store';
import { fetchMe } from './Redux/Slices/authSlice';
import { applyTheme, darkMediaQuery } from './lib/theme';
import AppRoutes from './Routes';

export default function App() {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((s) => s.ui.theme);

  // Restore the session on first paint so a refresh does not bounce to /login.
  useEffect(() => {
    void dispatch(fetchMe());
  }, [dispatch]);

  useEffect(() => {
    applyTheme(theme);
    // Only a `'system'` preference has anything to listen to: an explicit
    // light or dark is a decision the OS does not get to overrule.
    if (theme !== 'system') return;
    const query = darkMediaQuery();
    if (!query) return;
    const onChange = () => applyTheme('system');
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, [theme]);

  return <AppRoutes />;
}
